<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ma-0"
          style="height: 20px; width: 20px"
          icon
          v-bind="attrs"
          v-on="on"
          @click="translateText"
          :disabled="!textToTranslate || textToTranslate.length === 0"
        >
          <v-icon size="17" color="primary">mdi-translate</v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('languageTranslator.tooltip') }}{{ $t('languages.' + locale) }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'languageTranslator',
  props: {
    langEdition: {
      type: String,
      default: null,
    },
    textToTranslate: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      textTranslated: '',
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  created() {
    this.textTranslated = '';
  },
  methods: {
    async translateText() {
      if (this.langEdition && this.textToTranslate) {
        const text = await this.$kuzzle.query({
          controller: 'translate',
          action: 'text',
          body: {
            targetLang: this.langEdition,
            textToTranslate: this.textToTranslate,
          },
        });
        if (text) {
          if (this.type === 'answerList') {
            this.textTranslated = text.result.result[0].translations;
            this.$emit('text-translated', this.textTranslated, this.type);
          } else {
            this.textTranslated = text.result[0].translations[0].text;
            this.$emit('text-translated', this.textTranslated, this.type);
          }
        }
        this.textTranslated = '';
      }
    },
  },
};
</script>

<style lang="sass" scoped></style>
